// extracted by mini-css-extract-plugin
export default {"container":"AuthPage_container__zjPH4","onboard":"AuthPage_onboard__DOlJH"};